exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LX__iframePortal__container {\n  position: relative;\n}\n\n.LX__iframePortal__container .LX__iframePortal__frame {\n  border: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/apps/widgets/linkexchange-link/src/Banner/containers/iframePortal.scss"],"names":[],"mappings":"AAAA;EACE,mBAAkB;CAUnB;;AAXD;EAII,UAAS;EACT,mBAAkB;EAClB,OAAM;EACN,QAAO;EACP,YAAW;EACX,aAAY;CACb","file":"iframePortal.scss","sourcesContent":[".container {\n  position: relative;\n\n  .frame {\n    border: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "LX__iframePortal__container",
	"frame": "LX__iframePortal__frame"
};